import React from "react";
import GeneratePDF from "../components/GeneratePDF";
import HomepagePrint from "./printable/HomePrint";
import AboutUsPrint from "./printable/AboutUsPrint";
import TeamPrint from "./printable/TeamPrint";
import ServicesPrint from "./printable/ServicesPrint";
import GalleryPrint from "./printable/GalleryPrint";
import ContactUsPrint from "./printable/ContactUsPrint";

const BrochurePage = () => {
  return (
    <div>
      <style>
        {`
          #brochure-content {
            width: 100%;
          }

          .pdf-section {
            width: 100%;
            page-break-after: always;
            break-after: page;
          }

          .pdf-section:last-child {
            page-break-after: auto;
          }
        `}
      </style>

      <GeneratePDF
        targetId="brochure-content"
        fileName="SADP-Brochure.pdf"
      />

      <div id="brochure-content">

        <div className="pdf-section">
          <HomepagePrint />
        </div>

        <div className="pdf-section">
          <AboutUsPrint />
        </div>

        <div className="pdf-section">
          <TeamPrint />
        </div>

        <div className="pdf-section">
          <ServicesPrint />
        </div>

        <div className="pdf-section">
          <GalleryPrint />
        </div>

        <div className="pdf-section">
          <ContactUsPrint />
        </div>

      </div>
    </div>
  );
};

export default BrochurePage;
